import React from 'react';
import { trackLandingCTA } from '@/lib/analytics';
import { Reveal } from '../components/Reveal';
import { Button } from '@/components/ui/button';
import { FIRM_CONTACT_HREF } from './FirmInvite';

/**
 * Closing CTA -- marketing ruling M1 (2026-10-20). "the record" is left out
 * of the heading because the order-record sentence failed its [verify]
 * check (see ProofSection.tsx).
 */
export const CTASection: React.FC<{ onSignUp?: (tier?: string) => void }> = ({ onSignUp }) => {
  return (
    <section className="relative py-28 px-6 overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_hsla(162,72%,46%,0.08)_0%,_transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_hsla(190,90%,55%,0.04)_0%,_transparent_50%)]" />

      <Reveal
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative max-w-[760px] mx-auto text-center"
      >
        <h2 className="font-heading text-3xl md:text-[2.75rem] font-bold text-white mb-10 leading-tight">
          Open a paper account.{' '}
          <span className="text-gradient">See the limits and the rules before any money moves.</span>
        </h2>
        <div className="flex gap-4 justify-center flex-wrap">
          <Button size="lg" onClick={() => { trackLandingCTA('cta'); onSignUp?.('observer'); }} className="px-8 py-6 text-base glow-primary">
            Open a paper account
            <span className="ml-2">&rarr;</span>
          </Button>
          <a
            href={FIRM_CONTACT_HREF}
            onClick={() => trackLandingCTA('firm')}
            className="inline-flex items-center px-8 py-3 text-base text-white/70 border border-white/10 rounded-lg hover:border-white/20 hover:text-white transition-all cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2dd4a0]"
          >
            Running a firm? Write to us
          </a>
        </div>
      </Reveal>
    </section>
  );
};
